<script>
    import {api, store} from '../stores.js';
    import {Link} from 'svelte-routing';
    import TopMenu from '../components/TopMenu.svelte';
    import LoadingCard from '../components/LoadingCards.svelte';
    import Image from '../components/Image.svelte';
    import ImageCDN from '../components/ImageCDN.svelte';

    const user = store('credentials', 'appUserAuth');
    const tab = sessionStorage.getItem('tab-event') ? sessionStorage.getItem('tab-event') : 'all';
    const saveTab = (name) => sessionStorage.setItem('tab-event', name);
    const fetchAllEvents = (async () => {
        let result = await api('getGorodEvents', {gorod: $user.gorod});
        return result.data ? result.data : [];
    })();
    
    const fetchPaidEvents = (async () => {
        let result = await api('getMemberEvents', {login: $user.email, password: $user.pasport});
        return result.data ? result.data : [];
    })();
</script>

<TopMenu title="Список мероприятий" />

<div id="appCapsule">
    <div class="section full">
        <div class="wide-block transparent p-0">
            <ul class="nav nav-tabs lined iconed" role="tablist">
                <li class="nav-item" on:click={() => saveTab('all')}>
                    <a class="nav-link {'all' === tab ? 'active' : ''}" data-bs-toggle="tab" href="#all" role="tab" aria-selected="false">
                        Все мероприятия
                    </a>
                </li>
                <li class="nav-item" on:click={() => saveTab('paid')}>
                    <a class="nav-link {'paid' === tab ? 'active' : ''}" data-bs-toggle="tab" href="#paid" role="tab" aria-selected="false">
                        Мои мероприятия
                    </a>
                </li>
            </ul>
        </div>
    </div>
    
    <!-- tab content -->
    <div class="section full mb-2">
        <div class="tab-content">
            
            <!-- all -->
            <div class="tab-pane fade {'all' === tab ? ' active show' : ''}" id="all" role="tabpanel">
                {#await fetchAllEvents}
                    <LoadingCard />
                {:then data}
                    <div class="section">
                        {#if data.length}
                            <div class="row">
                                {#each data as {id, name, nameProd, otherScan}, i}
                                    <div class="col-12 col-md-6 col-lg-4">
                                        <div class="card my-2 mx-0">
                                            <Link to="/events/view/{id}">
                                                {#if otherScan}
                                                    <ImageCDN src="{otherScan}" class="card-img-top" alt="{nameProd}" style="height: 300px; width:100%; object-fit: cover;object-position: center center;" />
                                                {:else}
                                                    <Image src="/img/event.jpg" class="card-img-top" alt="{nameProd}" style="height: 300px; width:100%; object-fit: cover;object-position: center center;" />
                                                {/if}
                                            </Link>
                                            <div class="card-body">
                                                <h3>{nameProd}</h3>
                                                <p class="card-text">{@html name}</p>
                                            </div>
                                            <div class="card-footer">
                                                <Link to="/events/view/{id}" class="btn btn-primary btn-block">Просмотр</Link>
                                            </div>
                                        </div>
                                    </div>
                                {/each}
                            </div>
                        {:else}
                            <div class="error-page">
                                <h1 class="title">Мероприятий пока нет</h1>
                                <div class="text mb-5">
                                    Запланированные мероприятия будут отображаться на этой странице.
                                </div>
                            </div>
                        {/if}
                    </div>
                {/await}
            </div>
            <!-- * all -->
            
            <!--  paid -->
            <div class="tab-pane fade {'paid' === tab ? ' active show' : ''}" id="paid" role="tabpanel">
                {#await fetchPaidEvents}
                    <LoadingCard />
                {:then data}
                    <div class="section">
                        {#if data.length}
                            <div class="row">
                                {#each data as {id, name, produktName, datePlan, otherScan}, i}
                                    <div class="col-12 col-md-6 col-lg-4">
                                        <div class="card my-2 mx-0">
                                            <Link to="/events/view/{id}">
                                                {#if otherScan}
                                                    <ImageCDN src="{otherScan}" class="card-img-top" alt="{produktName}" style="height: 300px;object-fit: cover;object-position: center center;" />
                                                {:else}
                                                    <Image src="/img/event.jpg" class="card-img-top" alt="{produktName}" style="height: 300px;object-fit: cover;object-position: center center;" />
                                                {/if}
                                            </Link>
                                            <div class="card-body">
                                                <h3>{produktName}</h3>
                                                <p class="card-text">{@html name}</p>
                                            </div>
                                            <div class="card-footer">
                                                <div class="row">
                                                    <div class="col-6">
                                                        <Link to="/events/view/{id}" class="btn btn-primary btn-block">Просмотр</Link>
                                                    </div>
                                                    <div class="col-6">
                                                        <Link to="/events/view/{id}/tests" class="btn btn-outline-secondary btn-block">Материалы</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                {/each}
                            </div>
                        {:else}
                            <div class="error-page">
                                <h1 class="title">Вы пока не принимали участия ни в одном мероприятии</h1>
                                <div class="text mb-5">
                                    Когда это произойдет, они будут отображаться здесь.
                                </div>
                            </div>
                        {/if}
                    </div>
                {/await}
            </div>
            <!-- * paid -->
            
        </div>
    </div>
</div>
